import { FETCH_BRANDS_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_BRANDS_SUCCESS_ACTION:
      // console.log(action.payload.rows);
      return {
        ...state,
        BrandList: action.payload.rows,
        BrandCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
